import { registerSW } from 'virtual:pwa-register';

/**
 * Регистрация service worker (src/sw.ts). Вызывается один раз на старте.
 *
 * Новая сборка ставится сразу, без вопроса «обновить?»: worker получает
 * SKIP_WAITING и страница перезагружается при следующей навигации —
 * так у всех всегда текущая версия, а зависший «обновите» никто не видит.
 * В тестах и старых браузерах worker не поддерживается — тихо пропускаем.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  registerSW({ immediate: true });
}
